import api from './api';

export const eventsService = {
  // Get all events
  getEvents: (page = 1, limit = 20, status = null) => {
    const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
    if (status) params.append('status', status);
    return api.get(`/events?${params}`);
  },

  // Get upcoming events
  getUpcoming: (limit = 10) => {
    return api.get(`/events/upcoming?limit=${limit}`);
  },

  // Get completed events
  getCompleted: (page = 1, limit = 20) => {
    return api.get(`/events/completed?page=${page}&limit=${limit}`);
  },

  // Search events
  search: (query, page = 1, limit = 20) => {
    return api.get(`/events/search?q=${encodeURIComponent(query)}&page=${page}&limit=${limit}`);
  },

  // Get event by ID
  getEvent: (id) => {
    return api.get(`/events/${id}`);
  },

  // Get event by slug
  getEventBySlug: (slug) => {
    return api.get(`/events/slug/${slug}`);
  },

  // Create event (admin only)
  createEvent: (eventData) => {
    return api.post('/events', eventData);
  },

  // Update event (admin only)
  updateEvent: (id, eventData) => {
    return api.put(`/events/${id}`, eventData);
  },

  // Add images to gallery (admin only)
  addToGallery: (id, images) => {
    return api.put(`/events/${id}/gallery`, { images });
  },

  // Add videos (admin only)
  addVideos: (id, videos) => {
    return api.put(`/events/${id}/videos`, { videos });
  },

  // Update event status (admin only)
  updateStatus: (id, status) => {
    return api.put(`/events/${id}/status`, { status });
  },

  // Delete event (admin only)
  deleteEvent: (id) => {
    return api.delete(`/events/${id}`);
  },
};

export default eventsService;
